import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-158eb404")

_pushScopeId("data-v-158eb404")
const _hoisted_1 = { class: "flex gap-x-4 w-full justify-center py-4 border-l border-gray-lp-400" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!

  return (_openBlock(), _createBlock(_component_TimeRangePicker, {
    ref: "kulioner-report-time-range-picker",
    class: "download-reports-calendar",
    startDate: _ctx.form.startDate,
    endDate: _ctx.form.endDate,
    onSelect: _ctx.setDateRange,
    default: _ctx.$t('custom'),
    isSetMaxDate: "",
    customTotalMaxDate: 30,
    maxDate: new Date(),
    showOptions: 
        `${_ctx.$t('custom')}, ${_ctx.$t('7 hari terakhir')}, ${_ctx.$t(
          '14 hari terakhir'
        )}, ${_ctx.$t('30 hari terakhir')}`
      ,
    advanceStyle: {
        width: '550px',
        fontSize: 'text-sm',
        fontWeight: 'font-medium'
      },
    isConvertName: "",
    labelCustom: "Rentang tanggal",
    isResetOnChangeOption: ""
  }, {
    trigger: _withId(() => [
      _createVNode(_component_LpButton, {
        outline: "",
        title: "Download laporan",
        textColor: "red-lp-100",
        iconV2: "",
        "icon-left": "download-new",
        iconColor: "red-lp-100"
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_LpButton, {
          outline: "",
          title: "Atur ulang",
          textColor: "red-lp-100",
          iconColor: "red-lp-100",
          onClick: _ctx.onReset
        }, null, 8, ["onClick"]),
        _createVNode(_component_LpButton, {
          title: "Download data",
          textColor: "white",
          onClick: _ctx.onDownload,
          disabled: !_ctx.form.startDate || !_ctx.form.endDate
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["startDate", "endDate", "onSelect", "default", "maxDate", "showOptions"]))
})